// eslint-disable-next-line import/no-unused-modules
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import Entrypoint from './components/app/Entrypoint';
import store from './store';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <Entrypoint />
    </Provider>
  );
}

function unregisterServiceWorker() {
  try {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister();
      });
    }
  } catch {
    // nothing here
  }
}

unregisterServiceWorker();
